// Recapiti del cliente compilati nella schermata iniziale (facoltativi).
// Il telefono segue lo stesso criterio della chat (valida_campo "telefono" in
// cat-plugin/aenergiafacile_plugin/cambio_fornitore.py): 9-15 cifre, +39 se manca.
// Così il valore che il wizard passa non viene mai rifiutato a valle.

export type EsitoRecapito = { valore?: string; errore?: string };

export const ERRORE_TELEFONO = "Servono da 9 a 15 cifre";
export const ERRORE_EMAIL = "Manca la chiocciola o il dominio, es. nome@dominio.it";

const EMAIL_RE = /^[^\s@;]+@[^\s@;]+\.[^\s@;]{2,}$/;

export function validaTelefono(raw: string): EsitoRecapito {
  if (!raw.trim()) return { valore: undefined };
  const pulito = raw.replace(/[^0-9+]/g, "");
  const cifre = pulito.replace(/[^0-9]/g, "");
  if (cifre.length < 9 || cifre.length > 15) return { errore: ERRORE_TELEFONO };
  return { valore: pulito.startsWith("+") ? pulito : "+39" + pulito };
}

export function validaEmail(raw: string): EsitoRecapito {
  const v = raw.trim().toLowerCase();
  if (!v) return { valore: undefined };
  if (!EMAIL_RE.test(v)) return { errore: ERRORE_EMAIL };
  return { valore: v };
}
